import React, { FC } from 'react';

import { useTranslation } from 'react-i18next';
import { PrimaryButton, SecondaryButton } from 'common/components';
import { ReactComponent as CloseIcon } from 'applicaiton/assets/close.svg';
import { ReactComponent as CancelIcon } from 'applicaiton/assets/cancel.svg';
import { StyledModal } from './styles';

interface DeleteModalProps {
  profileName: string;
  onClose: () => void;
  onSubmit: () => void;
}

const DeleteModal: FC<DeleteModalProps> = ({
  profileName,
  onClose,
  onSubmit,
}) => {
  const { t } = useTranslation();
  return (
    <StyledModal>
      <CloseIcon onClick={onClose} />
      <h1>
        {t('professionalsListConfiguration.delete_professional.titlePart1')}{' '}
        <span>{profileName}</span>{' '}
        {t('professionalsListConfiguration.delete_professional.titlePart2')}
      </h1>
      <div>
        <p>
          {' '}
          {t('professionalsListConfiguration.delete_professional.description')}
        </p>
        <div>
          <CancelIcon />
          {t(
            'professionalsListConfiguration.delete_professional.descriptionText1',
          )}
        </div>
        <div>
          {t(
            'professionalsListConfiguration.delete_professional.descriptionText2',
          )}
        </div>
      </div>
      <section>
        <SecondaryButton onClick={onClose}>
          {t('professionalsListConfiguration.delete_professional.cancel')}
        </SecondaryButton>
        <PrimaryButton onClick={onSubmit} styleType={'error'}>
          {t('professionalsListConfiguration.delete_professional.confirm')}
        </PrimaryButton>
      </section>
    </StyledModal>
  );
};

export default DeleteModal;
